
export const userType = () => {
  let obj = { isMA: false };
  const result = JSON.parse(localStorage.getItem('User'));
  if (result?.roleId?.slug === "master-admin") {
    obj.isMA = true;
  }
  return obj;
};
